import gql from 'graphql-tag';

export const CREATE_EVENT = gql`
  mutation CreateEvent(
    $ownerFirstName: String!
    $ownerLastName: String!
    $fianceeFirstName: String!
    $fianceeLastName: String!
    $calendarDate: CalendarDate
    $date: Float
    $tzid: String
    $place: String
    $placeId: String
    $lat: Float
    $lng: Float
    $template: String
    $theme: String
    $font: String
    $graphicAccent: String
    $enableTranslucentEffect: Boolean!
    $useSuggestedBackgroundColor: Boolean!
    $useWeddingColor: Boolean!
    $paletteId: String
    $paletteName: String
    $accentColor: [Float]
    $baseColor: [Float]
    $accentText: [Float]
    $baseText: [Float]
    $accentLightText: Boolean!
    $baseLightText: Boolean!
  ) {
    createEvent(
      ownerFirstName: $ownerFirstName
      ownerLastName: $ownerLastName
      fianceeFirstName: $fianceeFirstName
      fianceeLastName: $fianceeLastName
      date: $date
      calendarDate: $calendarDate
      tzid: $tzid
      place: $place
      placeId: $placeId
      lat: $lat
      lng: $lng
      template: $template
      theme: $theme
      font: $font
      graphicAccent: $graphicAccent
      enableTranslucentEffect: $enableTranslucentEffect
      useSuggestedBackgroundColor: $useSuggestedBackgroundColor
      useWeddingColor: $useWeddingColor
      paletteId: $paletteId
      paletteName: $paletteName
      accentColor: $accentColor
      baseColor: $baseColor
      accentText: $accentText
      baseText: $baseText
      accentLightText: $accentLightText
      baseLightText: $baseLightText
    ) {
      __typename
      website
      eventId
    }
  }
`;
